import { useAuth } from '@schooly/components/authentication';
import { useMemo } from 'react';

import { pickThreadUserProps } from './utils';

export const useThreadUser = () => {
  const { currentUser, currentStaff } = useAuth();

  return useMemo(() => {
    if (!currentUser || !currentStaff) return null;
    return pickThreadUserProps({ user_id: currentUser.user_id, ...currentStaff });
  }, [currentUser, currentStaff]);
};
